import axios from 'axios';
import { UserDTO } from '@inversor-hub/types';

const CONTRACT_FIELD_LABELS: { field: keyof UserDTO; label: string }[] = [
  { field: 'name', label: 'el nombre' },
  { field: 'surnames', label: 'los apellidos' },
  { field: 'documentNumber', label: 'el DNI/NIE' },
  { field: 'address', label: 'la dirección' },
  { field: 'city', label: 'la ciudad' },
  { field: 'postalCode', label: 'el código postal' },
];

/** Mirrors User.getMissingContractData in the API so the sign button can be blocked upfront. */
export function getMissingContractData(user?: UserDTO): string[] {
  if (!user) {
    return [];
  }

  return CONTRACT_FIELD_LABELS.filter(({ field }) => !String(user[field] ?? '').trim()).map(
    ({ label }) => label
  );
}

/** The API rejects incomplete profiles with `403 { error }`; show that reason, not a generic one. */
export function getSignErrorMessage(error: unknown): string {
  const fallback = 'Error al firmar el contrato';
  if (!axios.isAxiosError(error)) {
    return fallback;
  }

  const data = error.response?.data as { error?: string; message?: string } | undefined;
  return data?.error ?? data?.message ?? fallback;
}
